<template>
  <div class="task-list" v-loading="loading">
    <div class="task-list-box">
      <task-item
        v-for="task in tasks"
        :key="task.id"
        :task="task"
        :type="type"
      />
      <div class="pagination" v-if="tasks.length">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.current"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="page.size"
          layout="total, sizes, prev, pager, next"
          :total="page.total"
        />
      </div>
      <el-empty description="暂无数据" v-else></el-empty>
    </div>
  </div>
</template>

<script>
import TaskItem from "./taskItem";
import {
  getMyTodo,
  getMyCompleteTodo,
  getMyHistoryTodo,
  getMyLaunchTodo,
} from "../../api/task";
import bus from "./bus";
export default {
  name: "taskList",
  components: {
    TaskItem,
  },
  props: {
    type: String,
  },
  data() {
    return {
      tasks: [],
      bus,
      loading: false,
      page: {
        current: 1,
        size: 10,
        total: 0,
      },
      apiType: {
        todo: getMyTodo,
        completed: getMyCompleteTodo,
        launch: getMyLaunchTodo,
        history: getMyHistoryTodo,
      },
    };
  },
  watch: {},
  computed: {},
  destroyed() {
    this.bus.$off("Refresh");
  },
  created() {
    this.getTaskList();
  },
  mounted() {
    this.bus.$on("Refresh", () => {
      this.getTaskList();
    });
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.page.size = val;
      this.page.current = 1; // 切换每页数量后回到第一页
      this.getTaskList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page.current = val;
      this.getTaskList();
    },
    getTaskList() {
      this.loading = true;
      const { current, size } = this.page;
      this.apiType[this.type]({
        current,
        size,
      })
        .then((res) => {
          this.tasks = res.data.records || [];
          this.page.total = res.data.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.task-list {
  border-radius: 20px;
  flex: 1;
  background: #f6f6f6;
  padding: 20px;
  box-sizing: border-box;
  overflow: hidden;
  .task-list-box {
    // height: calc(100%);
    overflow: auto;
    height: 100%;
    &::-webkit-scrollbar {
      width: 10px;
      height: 10px;
      background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 8px;
      background-clip: content-box;
      border: 2px solid transparent;
    }
  }
}
.pagination {
  display: flex;
  justify-content: flex-end;
}
</style>